module.exports = __webpack_public_path__ + "img/cspace-facebookpage.a892cceb.svg";